// extracted by mini-css-extract-plugin
module.exports = {"modal":"_modal_modal__blpTO","content":"_modal_content__AaD0p","message":"_modal_message__7sloU","actions":"_modal_actions__xn5fR"};